export const transformSearchResponse = (data) => {
  let result = data?.data?.map((data) => {
    let orderPriorityDetail = {
      code: data.orderPriority.code ?? null,
      name: data.orderPriority.name ?? null,
    };
    let partListDetail = data?.parts?.map((list) => ({
      partNumber: list.externalId ?? null,
      name: list.name ?? null,
      lifecycleState: list.lifecycleState ?? null,
    }));
    let latestMilestoneDetail = {
      eventCode: data.lastMilestone.eventCode ?? null,
      //TODO: Update the 'datetime' to camelcase 'dateTime' once the open search result is finalized
      datetime: data.lastMilestone.eventTs ?? null,
      receivedDatetime: data.lastMilestone.receivedTs ?? null,
      location: data.lastMilestone.location ?? null,
    };
    let latestUpdateDetail = {
      eventCode: data.lastUpdate.eventCode ?? null,
      datetime: data.lastUpdate.eventTs ?? null,
      receivedDatetime: data.lastUpdate.receivedTs ?? null,
      location: data.lastUpdate.location ?? null,
    };
    let ordersDetail = data?.orders?.map((data) => ({
      OrderNumber: data.externalId ?? null,
      OrderTimestamp: data.receivedTs ?? null,
    }));
    return {
      ...data,
      id: data.packageContainerId ?? null,
      TrackingNumber: data.trackingNumber ?? null,
      TrailerEquipmentNumber: data.trailerEquipmentNumber ?? null,
      Watched: data.watched ?? null,
      LifecycleState: data.lifecycleState ?? null,
      OwnerSolutionId: data.ownerSolutionId ?? null,
      OrderPriority: data.orderPriority ? orderPriorityDetail : null,
      FinalMileOrigin: data.finalTripLegOriginLocationName ?? null,
      PartList: data.parts ? partListDetail : null,
      OriginDetail: data.originDetail ?? null,
      DestinationDetail: data.destinationDetail ?? null,
      LastMilestone: data.lastMileStone ? latestMilestoneDetail : null,
      LastUpdate: data.lastUpdate ? latestUpdateDetail : null,
      ActiveExceptionList: data.activeExceptions ?? null,
      Orders: data.orders ? ordersDetail : null,
      DestinationEta: data.destinationEtaDisplay ?? null,
    };
  });
  return {
    ...data,
    data: result,
  };
};

export const transformData = (data) => {
  let result = data?.data?.map((data) => {
    return {
      ...data,
      PartList: data?.PartList?.map((item) => {
        //Remove actualQuantity and lifecycleState for search response from postGres
        return {
          name: item?.name,
          partNumber: item?.partNumber,
        };
      }),
    };
  });
  return { ...data, data: result };
};
